/**
 * 发票 store
 */
import invoiceApi from '../../api/invoice.api'
const state = {
	orderData: null,
	openInvoice: false,
	orderMount: 0
}
const getters = {}
const mutations = {
	setInvoiceState(state, data) {
		for (let keys in data) {
			if (data.hasOwnProperty(keys)) {
				state[keys] = data[keys]
			}
		}
	}
}
const actions = {
	// 获取发票列表
	getListByUserid({ state }, data) {
		return invoiceApi.listByUserid(data)
	},
	// 填写发票信息
	postAddTicket({ state }, data) {
		return invoiceApi.addTicket(data)
	},

	// 添加发票订单
	PostAddOrder({ state }, data) {
		return invoiceApi.addOrder(data)
	},
	downInvoice({ state }, data) {
		return invoiceApi.downInvoice(data)
	},
	getProfInvoiceLimitMoney(context) {
		return invoiceApi.getProfInvoiceLimitMoney()
	},
	/**
	 * 获取上次提交的专票信息
	 * @param {String} params.uid
	 */
	getProfLastInvoice(context, params) {
		return invoiceApi.getProfLastInvoice(params)
	},
	checkContract(context, params) {
		return invoiceApi.checkContract(params)
	}
}

export default {
	state,
	getters,
	mutations,
	actions,
	namespaced: true
}
